// extracted by mini-css-extract-plugin
export default {"row":"info-row_row__p21KD","label":"info-row_label__pHQol","text":"info-row_text__AqFfx"};